module.exports = __webpack_public_path__ + "img/img_t2@2x.b74e6e7c.png";